import { graphql, useLazyLoadQuery } from "react-relay";
import { useNavigate, useSearchParams } from "react-router";

import { useAlertContext } from "app/contexts";
import { AdminPage } from "app/views/admin/AdminPage";

import { UpsertDpcForm } from "../components/UpsertDpcForm";
import { type EditDpcRootQuery } from "./__generated__/EditDpcRootQuery.graphql";

export function EditDpcRoot() {
  const { alertDispatch } = useAlertContext();
  const [searchParams] = useSearchParams({});
  const collectionUUID = searchParams.get("collectionUUID") || "";
  const navigate = useNavigate();

  const data = useLazyLoadQuery<EditDpcRootQuery>(
    graphql`
      query EditDpcRootQuery(
        $uuid: String!
        $accountGroupFilterElement: FilterElementInput
      ) {
        ...AdminPage_query
        policyCollection(uuid: $uuid) {
          repositoryConfig {
            uuid
          }
          ...UpsertDpcForm_policyCollection
        }
        ...UpsertDpcForm_query
      }
    `,
    {
      uuid: collectionUUID || "",
    },
  );

  const onUpdated = (message: string) => {
    alertDispatch({
      message,
      severity: "success",
    });
  };

  function navigateBack() {
    navigate(`/admin/policy-collections/${collectionUUID}`);
  }

  if (!data.policyCollection) {
    return null;
  }

  return (
    <AdminPage queryRef={data} title="Edit dynamic policy collection" isForm>
      <UpsertDpcForm
        onAdded={(message) => {
          onUpdated(message);
          navigateBack();
        }}
        onCancel={navigateBack}
        queryRef={data.policyCollection}
        queryRefAcl={data}
        repositoryUUID={data.policyCollection?.repositoryConfig?.uuid || ""}
      />
    </AdminPage>
  );
}
